import * as React from 'react';
import { ApolloError } from 'apollo-client';
import { Query } from 'react-apollo';

import OWNED_GROUP_SUMMARIES_QUERY from 'groups/queries/LoadOwnedGroupSummariesQuery.gql';
import {
  LoadOwnedGroupSummaries,
  LoadOwnedGroupSummaries_me_classes,
} from 'groups/queries/__generated__/LoadOwnedGroupSummaries';

export type Props = {
  children: (props: {
    ownedGroups?: LoadOwnedGroupSummaries_me_classes[];
    loading: boolean;
    error?: ApolloError;
  }) => React.ReactNode;
};

export default function OwnedGroupSummariesFetcher(props: Props) {
  return (
    <Query<LoadOwnedGroupSummaries> query={OWNED_GROUP_SUMMARIES_QUERY}>
      {({ loading, error, data }) => {
        const groups = (data && data.me && data.me.classes) || undefined;
        const ownedGroups =
          groups &&
          groups.filter<LoadOwnedGroupSummaries_me_classes>(
            (group): group is LoadOwnedGroupSummaries_me_classes =>
              !!group && group.type === 'owned'
          );
        return props.children({ ownedGroups, loading, error });
      }}
    </Query>
  );
}
